import { sendHttpRequest } from "lib/fetcher";
export const saveTemplateToIpSpeaker = async (
  speakerId,
  assetTemplateId,
  orgId,
) => {
  return await sendHttpRequest({
    method: "patch",
    url: `/speaker/speakers/${speakerId}/audio_template`,
    data: {
      assetTemplateId,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
};

export const updateSpeaker = async (speakerId, data, orgId) => {
  return await sendHttpRequest({
    method: "patch",
    url: `/speaker/speakers/${speakerId}`,
    data: data,
    headers: {
      "x-org-id": orgId,
    },
  });
};
